/**
 * 知识库 API 常量。请求仍走 this.$http，不新建 axios。
 */
/** 助手入口鉴权 URI（admin_rule.name=/kb/ask，title=知识库问答）；无权限不渲染漂浮球 */
export const KB_ASK_PERMISSION = '/kb/ask'

export const KB_URI = {
  askAllowed: '/kb/askAllowed',
  ask: '/kb/ask',
  baseList: '/kb/base/list',
  baseSave: '/kb/base/save',
  baseSync: '/kb/base/sync',
  browse: '/kb/browse',
  upload: '/kb/upload',
  groupBinds: '/kb/group/binds',
  groupBind: '/kb/group/bind',
  providerStatus: '/kb/provider/status',
  providerBases: '/kb/provider/bases'
}

export const KB_FAB_POS_KEY = 'kb_assistant_fab_pos'
/** 对话窗位置与尺寸 { left, top, width, height } */
export const KB_WIN_GEOM_KEY = 'kb_assistant_win_geom'



// WEBPACK FOOTER //
// ./src/tools/kbApi.js